import { addMonths, startOfMonth } from "date-fns";

export const getDefaultFutureContractStartDate = (
	now: Date = new Date(),
): Date => startOfMonth(addMonths(now, 1));
